export const T_Major = 0;
export const T_Branch = 1;
export const T_LeafBool = 2;
export const T_LeafOptionsSingle = 3;
export const T_LeafOptionsMulti = 4;
export const T_LeafOptionsMultiOrdered = 5;

